import { useEffect, useState, type CSSProperties, type FC } from "react";

const overlayStyles: CSSProperties = {
    position: "absolute",
    inset: "0",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(2px)",
    borderRadius: "0 0 8px 8px",
};

const contentStyles: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    color: "white",
    fontFamily: "inherit",
};

const textStyles: CSSProperties = {
    fontSize: "1.125rem",
    fontWeight: 500,
    margin: 0,
};

const spinnerStyles: CSSProperties = {
    width: "32px",
    height: "32px",
    border: "3px solid rgba(255, 255, 255, 0.3)",
    borderTop: "3px solid white",
    borderRadius: "50%",
    animation: "reconnecting-spin 1s linear infinite",
};

export const ReconnectingModal: FC = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOffline(false);
        const handleOffline = () => setIsOffline(true);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    if (!isOffline) return;

    return (
        <div style={overlayStyles} role="alert" aria-live="assertive">
            <style>
                {`
                    @keyframes reconnecting-spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
            <div style={contentStyles}>
                <div style={spinnerStyles} aria-hidden="true" />
                <p style={textStyles}>Reconnecting...</p>
            </div>
        </div>
    );
};
